import { render, staticRenderFns } from "./paper-list.vue?vue&type=template&id=d7a8a5bc&scoped=true"
import script from "./paper-list.vue?vue&type=script&lang=ts"
export * from "./paper-list.vue?vue&type=script&lang=ts"
import style0 from "./paper-list.vue?vue&type=style&index=0&id=d7a8a5bc&prod&lang=scss"
import style1 from "./paper-list.vue?vue&type=style&index=1&id=d7a8a5bc&prod&lang=scss&scoped=true"
import style2 from "./paper-list.vue?vue&type=style&index=2&id=d7a8a5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a8a5bc",
  null
  
)

export default component.exports